export default __webpack_public_path__ + "static/media/ChatWithUs.ea85548f.svg";